import { z } from "zod"

/* -------------------------------------------------------------------------------------------------
 * errors
 * -----------------------------------------------------------------------------------------------*/
enum ApiFailure {
  FETCH_ERROR = "FETCH_ERROR",
  TIMEOUT_ERROR = "TIMEOUT_ERROR",
  RESPONSE_PARSING_ERROR = "RESPONSE_PARSING_ERROR",
  INVALID_ERROR_RESPONSE_ERROR = "INVALID_ERROR_RESPONSE_ERROR",
  INVALID_SUCCESS_RESPONSE_ERROR = "INVALID_SUCCESS_RESPONSE_ERROR",
  UNPROCESSABLE_ERROR = "UNPROCESSABLE_ERROR",
}

class UnhandledApiError extends Error {
  status: ApiFailure
  originalStatus?: number

  data?: any
  meta?: { request: Request; response?: Response }

  override stack?: string

  constructor({
    status,
    originalStatus,
    data,
    meta,
    stack = "",
    message,
  }: {
    status: ApiFailure
    originalStatus?: number
    data?: any
    meta?: { request: Request; response?: Response }
    stack?: string
    message: string
  }) {
    super(message)
    this.status = status
    this.meta = meta
    this.originalStatus = originalStatus
    this.data = data
    if (stack) {
      this.stack = stack
    } else {
      Error.captureStackTrace(this, this.constructor)
    }
  }
}

/* -------------------------------------------------------------------------------------------------
 * schemas
 * -----------------------------------------------------------------------------------------------*/

const baseApiResponseSchema = z.object({
  status: z.string(),
  requestId: z.string(),
  datetime: z.string(),
})

type BaseApiResponse = z.infer<typeof baseApiResponseSchema>

const errorInfosSchema = z.record(z.string(), z.array(z.string())).optional()

const baseApiErrorResponseSchema = z.object({
  status: z.string().optional(),
  error: z
    .object({
      type: z.string(),
      message: z.string().optional(),
      errorInfos: errorInfosSchema,
    })
    .optional(),
})

type BaseApiErrorResponse = z.infer<typeof baseApiErrorResponseSchema>

/* -------------------------------------------------------------------------------------------------
 * utils
 * -----------------------------------------------------------------------------------------------*/

export {
  ApiFailure,
  baseApiErrorResponseSchema,
  baseApiResponseSchema,
  errorInfosSchema,
  UnhandledApiError,
}
export type { BaseApiErrorResponse, BaseApiResponse }
